const password_restore = {
    title: String("Recuperación de contraseña"),
    newPasswordAsk: String("Introduce la nueva contraseña."),
    changePasswordButton: String("Cambiar contraseña"),
    passwordChanged: String("La contraseña ha sido cambiada correctamente."),
    emailNotFound: String("El email no existe, por favor introduce un email válido."),
    keyError: String("Existe algún problema con el link de recuperación de contraseña. Vuelve a clicar sobre el botón del email o bien vuelve rellenar el formulario de 'Has olvidado tu contraseña?'."),
};

export default password_restore;